import { portalApi } from "portal/state/portalApi";
import { skipToken } from "@reduxjs/toolkit/query";
import { useJigsawMetrics } from "../../utils/hooks/useJigsawMetrics";
import { useParams } from "react-router-dom";
import { useQueryPopups } from "portal/utils/hooks/useApiPopups";
import { useTranslation } from "react-i18next";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import React, { FunctionComponent } from "react";

const _RobotVersionsList: FunctionComponent = () => {
  const { serial } = useParams();
  const { i18n, t } = useTranslation();
  const useJigsaw = useJigsawMetrics();

  const { data: summary, isSuccess } = useQueryPopups(
    portalApi.endpoints.getRobot.useQuery(
      serial ? { language: i18n.language, serial, useJigsaw } : skipToken
    )
  );

  return (
    <div>
      <div>
        <span className="font-bold mr-2">
          {t("views.fleet.robots.hardware.installedVersion")}
        </span>
        {isSuccess
          ? summary.robot?.health?.softwareVersion
          : t("components.Loading.placeholder")}
      </div>
      <div>
        <span className="font-bold mr-2">
          {t("views.fleet.robots.hardware.targetVersion")}
        </span>
        {isSuccess
          ? summary.robot?.health?.targetVersion
          : t("components.Loading.placeholder")}
      </div>
      <div>
        <span className="font-bold mr-2">
          {t("views.fleet.robots.hardware.ready.name")}:
        </span>
        {(() => {
          if (!isSuccess) {
            return t("components.Loading.placeholder");
          }
          return summary.robot?.health?.targetVersionReady
            ? t("views.fleet.robots.hardware.ready.values.true")
            : t("views.fleet.robots.hardware.ready.values.false");
        })()}
      </div>
    </div>
  );
};

export const RobotVersionsList = withAuthenticationRequired(_RobotVersionsList);
